/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

/**
 * Includes:
 * Fonts
 * Bootstrap
 * Generics
 */
import "./src/assets/stylesheets/styles.scss";

import React from "react";
import SSRProvider from "react-bootstrap/SSRProvider";

const scrollTo = (id) => () => {
	const el = document.querySelector(id);
	if (el) return window.scrollTo(0, el.offsetTop - 20);
	return false;
};

export const onRouteUpdate = ({ location: { hash } }) => {
	console.log(location);
	if (hash) {
		window.setTimeout(scrollTo(hash), 10);
	}
};
/** Wrap root element. */
export const wrapRootElement = ({ element }) => {
	return <SSRProvider>{element}</SSRProvider>;
};
